export default __webpack_public_path__ + "4cd05d6e20eefe0dd543ef52a9846371.jpg";